import { useContext, useEffect, useState } from 'react';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';
import { ActiveApplicationContext, SetActiveApplicationContext, UserApplicationsContext } from '@trinity/chat-components/containers/UserApplications/UserApplicationsContext.js';
import { ActiveBrandContext } from '@trinity/chat-components/containers/UserBrands/UserBrandsContext.js';
import { useAppReadyState } from '../AppReadyState';

type Props = {
  children: React.ReactNode;
};

export const UserApplicationsContainer = (props: Props) => {
  const app = useAppReadyState();

  const activeBrandIdentifier = useContext(ActiveBrandContext);
  const [activeApplicationIdentifier, setActiveApplicationIdentifier] = useState<string | null>(null);

  const apiClient = useChatApiClient();

  const q = useQuery({
    queryKey: ['get:user-applications', activeBrandIdentifier],
    queryFn: async () => {
      return await apiClient.users.getUserApplications();
    },
    enabled: app.authenticated,
    initialData: {},
    placeholderData: keepPreviousData,
  });

  useEffect(() => {
    if (q.isSuccess && activeBrandIdentifier) {
      const brandApplications = q.data[activeBrandIdentifier];
      if (brandApplications && brandApplications.length > 0) {
        // Check if there's a default application for this brand
        const defaultApp = brandApplications.find(app => app.isDefault === true);
        const appToSelect = defaultApp || brandApplications[0];
        
        setActiveApplicationIdentifier(appToSelect.identifier);
      }
    }
  }, [q.data, q.isSuccess, activeBrandIdentifier]);

  return (
    <ActiveApplicationContext.Provider value={activeApplicationIdentifier}>
      <SetActiveApplicationContext.Provider value={setActiveApplicationIdentifier}>
        <UserApplicationsContext.Provider value={q.data}>
          {props.children}
        </UserApplicationsContext.Provider>
      </SetActiveApplicationContext.Provider>
    </ActiveApplicationContext.Provider>
  );
};
